import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLanguageMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M22.3 17.73c0-.38-.32-.7-.7-.7H15a.69.69 0 0 0 0 1.39h6.6c.38 0 .7-.31.7-.7ZM9.69 20.72a.69.69 0 0 0 0 1.38h6.6a.69.69 0 0 0 0-1.38h-6.6ZM18.85 20.72a.69.69 0 0 0 0 1.38h2.75a.69.69 0 0 0 0-1.38h-2.75ZM12.44 17.04a.69.69 0 0 1 0 1.38H9.69a.69.69 0 0 1 0-1.38h2.75Z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m15.25 25.07-4.63 3.7A1 1 0 0 1 9 28v-2.92H7a2 2 0 0 1-2-2.01V8C5 6.9 5.9 6 7 6h18a2 2 0 0 1 2 2v15.06a2 2 0 0 1-2 2h-9.75Zm-4.75-1.51H7a.5.5 0 0 1-.5-.5V8c0-.28.22-.5.5-.5h18c.28 0 .5.22.5.5v15.05a.5.5 0 0 1-.5.5H14.72l-4.22 3.4v-3.4Z"
	})]
});
export { SvgLanguageMenu as ReactComponent };
